import { useMutation } from "react-query";
import downloadPaymentReconciliationCSV from "../services/downloadPaymentReconciliationCSV";

function useDownloadPaymentReconciliation() {
  return useMutation(["download-payment-reconciliation-csv"], downloadPaymentReconciliationCSV);
}

export default useDownloadPaymentReconciliation;